import Base from './Base';

export default class CreatorType extends Base {
  value = '';
  label = '';

  constructor(props) {
    super();
    this.clone(props);
  }
}
